import { motion } from "framer-motion";

interface SpecimenLabelProps {
  text: string;
  className?: string;
  delay?: number;
}

export const SpecimenLabel = ({ text, className = "", delay = 0 }: SpecimenLabelProps) => {
  return (
    <motion.span
      className={`specimen-label ${className}`}
      initial={{ opacity: 0, y: 5 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay, duration: 0.4 }}
    >
      {text}
    </motion.span>
  );
};

interface SpecimenBlockProps {
  label: string;
  value: string;
  className?: string;
  delay?: number;
}

export const SpecimenBlock = ({ label, value, className = "", delay = 0 }: SpecimenBlockProps) => {
  return (
    <motion.div
      className={`flex flex-col gap-1 ${className}`}
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay, duration: 0.5 }}
    >
      <span className="specimen-label">{label}</span>
      <span className="text-foreground font-medium">{value}</span>
    </motion.div>
  );
};
